class MrkFeaturesTab extends HTMLElement {
  constructor() {
    super();
    this.element = null;
    this.currentClassName = 'active';
    this.indexAttr = 'data-index';
    this.init();
  }

  init() {
    this.element = this.getElements();
    this.bindEvent();
  }

  getElements() {
    return {
      itemsNode: this.querySelector('.features-items'),
      itemNode: this.querySelectorAll('.features-items .item'),
      tabsNode: this.querySelector('.features-tabs'),
      tabNode: this.querySelectorAll('.features-tabs .tab')
    }
  }

  bindEvent() {
    if (this.element.itemsNode) {
      this.element.tabsNode.addEventListener('click', (e) => {
        const tabNode = e.target.closest('.tab');
        if (tabNode) {
          const index = parseFloat(tabNode.getAttribute(this.indexAttr));
          for (let i = 0; i < this.element.itemNode.length; i++) {
            const currentItemNode = this.element.itemNode[i];
            if (index === i) {
              currentItemNode.classList.add(this.currentClassName);
            } else {
              currentItemNode.classList.remove(this.currentClassName);
            }
          }
          for (let i = 0; i < this.element.tabNode.length; i++) {
            const currentTabNode = this.element.tabNode[i];
            if (index === i) {
              currentTabNode.classList.add(this.currentClassName);
            } else {
              currentTabNode.classList.remove(this.currentClassName);
            }
          }
        }
      })
    }
  }
}
customElements.define("mrk-features-tab", MrkFeaturesTab);

class LMrkCarouuselTab extends LMrkCarouusel {
  constructor() {
    super();

    this.tabItems = null;
  }
  // 初始化完成
  onInitComplete() {
    this.tabItems = this.querySelectorAll('.features-tabs .tab');
    this.tabsNode = this.querySelector('.features-tabs');

    if (this.tabsNode) {
      this.tabsNode.addEventListener('click', (e) => {
        if (this.isAnimate) return;
        const tabNode = e.target.closest('.tab')
        if (tabNode) {
          const index = tabNode.getAttribute(this.dataIndex)
          this.currentIndex = parseFloat(index) + this.copyFirstLastNum;
          this.updateCarousel();
        }
      });
    }

    if (this.direction === 'vertical') {
      const slidesNode = this.querySelector('.l-carousel-slides');
      if (slidesNode) {
        slidesNode.addEventListener('click', (e) => {
          if (this.isAnimate) return;
          const slideNode = e.target.closest('.l-carousel-slide')
          if (slideNode) {
            const index = slideNode.getAttribute(this.dataIndex)
            this.currentIndex = parseFloat(index) + this.copyFirstLastNum;
            this.updateCarousel();
          }
        });
      }
    }
  }

  // 轮播执行完成
  onExecuteEnd() {
    if (this.tabItems && this.tabItems.length) {
      this.tabItems.forEach(item => {
        item.classList.remove(this.activeClassName);
      })
      const itemNode = this.tabItems[this.currentIndex - this.copyFirstLastNum]
      itemNode.classList.add(this.activeClassName);
    }
  }
}
customElements.define("l-mrk-carouusel-tab", LMrkCarouuselTab);

document.addEventListener('DOMContentLoaded', () => {
  bindStandardEvents();

  // The New Standard for Home Brewers. 查看详情按钮
  function bindStandardEvents() {
    const allClassName = 'is-all-active';
    const sectionsNode = document.querySelectorAll('.review-standard-section');

    if (sectionsNode) {
      sectionsNode.forEach((sectionNode) => {
        sectionNode.addEventListener('click', (e) => {
          const btnNode = e.target.closest('.all-btn');
          const slideNode = e.target.closest('.standard-slide');
          
          const slidesNode = e.currentTarget.querySelectorAll('.standard-slide');

          slidesNode.forEach((slide) => {
            slide.classList.remove(allClassName);
          })

          if (btnNode) {
            if (!slideNode.classList.contains(allClassName)) {
              slideNode.classList.add(allClassName);
            } else {
              slideNode.classList.remove(allClassName);
            }
          } else if (slideNode) {
            if (slideNode.classList.contains(allClassName)) {
              slideNode.classList.remove(allClassName);
            }
          }
        })
      })
    }
  }
});